import "babel-polyfill";

import "./libs/slick";

import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {headerNav} from "./modules/headerNav";
import {lionAnimation} from "./modules/lionAnimation";
import {videoHolder} from "./modules/videoHolder";
import {caseStudySlider} from "./modules/caseStudySlider";
import {accordion} from "./modules/accordion";
import {preloaderAnimation} from "./modules/preloaderAnimation";
import {animationOnScroll} from "./modules/animationOnScroll";
import {videoPopup} from "./modules/videoPopup";
import {marqueeSection} from "./modules/marquee-section";
import {imagePopup} from "./modules/imagePopup";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": headerNav,
        ".canvas-holder": lionAnimation,
        ".video-holder": videoHolder,
        ".case-study-slider": caseStudySlider,
        ".accordion-holder": accordion,
        ".preloader": preloaderAnimation,
        ".has-animation": animationOnScroll,
        ".video-popup-opener": videoPopup,
        ".marquee-section": marqueeSection,
        ".photo-popup-opener": imagePopup
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js